module.exports = __webpack_public_path__ + "img/7.55a93b7c.png";